module.exports = __webpack_public_path__ + "static/media/nosearch.b03c00d2.svg";